import { render, staticRenderFns } from "./hpLogoMinimal.vue?vue&type=template&id=080b1086&"
import script from "./hpLogoMinimal.vue?vue&type=script&lang=js&"
export * from "./hpLogoMinimal.vue?vue&type=script&lang=js&"
import style0 from "./hpLogoMinimal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports